"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResumeWorkHistory = exports.ResumeVolunteer = exports.ResumeSummary = exports.ResumeSkills = exports.ResumeQualifications = exports.ResumeName = exports.ResumeEducation = exports.ResumeContact = exports.ResumeCertifications = exports.Resume = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _dateFns = require("date-fns");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./pixelated.resume.css");
var _pixelatedResume2 = _interopRequireDefault(require("./pixelated.resume.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable */
function isValidDate(date) {
  return !Number.isNaN(new Date(date).getTime());
}
class Resume extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("section", {
      className: "p-resume",
      id: "resume-section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "section-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "p-name grid12"
    }, /*#__PURE__*/_react.default.createElement(ResumeName, {
      data: this.props.data
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "grid3 bigpad divider"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "p-contact"
    }, /*#__PURE__*/_react.default.createElement(ResumeContact, {
      data: this.props.data
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "p-education"
    }, /*#__PURE__*/_react.default.createElement(ResumeEducation, {
      data: this.props.data,
      dateFormat: "MM/yyyy",
      showDate: true
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "p-skills"
    }, /*#__PURE__*/_react.default.createElement(ResumeSkills, {
      data: this.props.data
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "grid9 bigpad"
    }, /*#__PURE__*/_react.default.createElement(ResumeSummary, {
      data: this.props.data
    }), /*#__PURE__*/_react.default.createElement(ResumeQualifications, {
      data: this.props.data
    }), /*#__PURE__*/_react.default.createElement(ResumeWorkHistory, {
      data: this.props.data,
      dateFormat: "MM/yyyy",
      showDate: true
    }), /*#__PURE__*/_react.default.createElement(ResumeVolunteer, {
      data: this.props.data,
      dateFormat: "MM/yyyy",
      showDate: true
    }), /*#__PURE__*/_react.default.createElement(ResumeCertifications, {
      data: this.props.data,
      dateFormat: "MM/yyyy",
      showDate: true
    }))));
  }
}
exports.Resume = Resume;
class ResumeName extends _react.Component {
  render() {
    var myName = this.props.data.items[0].properties.contact[0].properties.name;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", {
      className: "p-name"
    }, myName));
  }
}
exports.ResumeName = ResumeName;
_defineProperty(ResumeName, "propTypes", {
  data: _propTypes.default.object.isRequired
});
class ResumeContact extends _react.Component {
  render() {
    var myContact = this.props.data.items[0].properties.contact[0];
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Contact Information"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "p-email"
    }, myContact.properties.email[0])), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "p-street-address"
    }, myContact.properties.adr[0].properties["street-address"], ", "), /*#__PURE__*/_react.default.createElement("span", {
      className: "p-locality"
    }, myContact.properties.adr[0].properties.locality, ", "), /*#__PURE__*/_react.default.createElement("span", {
      className: "p-region"
    }, myContact.properties.adr[0].properties.region, " "), /*#__PURE__*/_react.default.createElement("span", {
      className: "p-postal-code"
    }, myContact.properties.adr[0].properties["postal-code"])), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "p-tel"
    }, myContact.properties.tel[0])), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "p-url"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: myContact.properties.url[0]
    }, myContact.properties.url[0])))));
  }
}
exports.ResumeContact = ResumeContact;
_defineProperty(ResumeContact, "propTypes", {
  data: _propTypes.default.object.isRequired
});
class ResumeEducation extends _react.Component {
  render() {
    var myElems = [];
    var myEducation = this.props.data.items[0].properties.education;
    for (var iKey in myEducation) {
      var ed = myEducation[iKey];
      var myEdLocation = ed.properties.location[0].properties;
      var myEndDate = isValidDate(ed.properties.end[0]) ? (0, _dateFns.format)(new Date(ed.properties.end[0]), this.props.dateFormat) : ed.properties.end[0];
      var myElem = /*#__PURE__*/_react.default.createElement("li", {
        key: iKey
      }, this.props.showDate == true ? /*#__PURE__*/_react.default.createElement("span", {
        className: "dt-end"
      }, myEndDate, " - ") : '', /*#__PURE__*/_react.default.createElement("span", {
        className: "p-name"
      }, ed.properties.name, ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-org"
      }, myEdLocation.org, ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-locality"
      }, myEdLocation.locality, ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-region"
      }, myEdLocation.region, " "));
      myElems.push(myElem);
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Education"), /*#__PURE__*/_react.default.createElement("ul", null, myElems));
  }
}
exports.ResumeEducation = ResumeEducation;
_defineProperty(ResumeEducation, "propTypes", {
  data: _propTypes.default.object.isRequired,
  dateFormat: _propTypes.default.string.isRequired,
  showDate: _propTypes.default.bool.isRequired
});
class ResumeQualifications extends _react.Component {
  render() {
    var myElems = [];
    var myQual = this.props.data.items[0].properties.qualifications;
    for (var iKey in myQual) {
      var qual = myQual[iKey];
      var myElem = /*#__PURE__*/_react.default.createElement("h3", {
        key: iKey
      }, iKey);
      var quals = qual.map((qualItem, iKey) => /*#__PURE__*/_react.default.createElement("li", {
        key: "i" + iKey,
        className: "p-qualification"
      }, qualItem));
      myElems.push(myElem);
      myElems.push( /*#__PURE__*/_react.default.createElement("ul", {
        key: "q-" + iKey
      }, quals));
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Professional Qualifications"), myElems);
  }
}
exports.ResumeQualifications = ResumeQualifications;
_defineProperty(ResumeQualifications, "propTypes", {
  data: _propTypes.default.object.isRequired
});
class ResumeWorkHistory extends _react.Component {
  render() {
    var myElems = [];
    var myWork = this.props.data.items[0].properties.experience;
    for (var iKey in myWork) {
      var work = myWork[iKey];
      var myStartDate = isValidDate(work.properties.start[0]) ? (0, _dateFns.format)(new Date(work.properties.start[0]), this.props.dateFormat) : work.properties.start[0];
      var myEndDate = isValidDate(work.properties.end[0]) ? (0, _dateFns.format)(new Date(work.properties.end[0]), this.props.dateFormat) : work.properties.end[0];
      var myWorkLocation = work.properties.location[0].properties;
      var myElem = /*#__PURE__*/_react.default.createElement("li", {
        key: iKey
      }, this.props.showDate == true ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "dt-start"
      }, myStartDate, " - "), /*#__PURE__*/_react.default.createElement("span", {
        className: "dt-end"
      }, myEndDate, " : ")) : '', /*#__PURE__*/_react.default.createElement("span", {
        className: "p-job-title"
      }, myWorkLocation["job-title"], ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-org"
      }, myWorkLocation.org, ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-locality"
      }, myWorkLocation.locality, ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-region"
      }, myWorkLocation.region, " "));
      myElems.push(myElem);
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Work History"), /*#__PURE__*/_react.default.createElement("ul", null, myElems));
  }
}
exports.ResumeWorkHistory = ResumeWorkHistory;
_defineProperty(ResumeWorkHistory, "propTypes", {
  data: _propTypes.default.object.isRequired,
  dateFormat: _propTypes.default.string.isRequired,
  showDate: _propTypes.default.bool.isRequired
});
class ResumeVolunteer extends _react.Component {
  render() {
    var myElems = [];
    var myVolunteer = this.props.data.items[0].properties.volunteer;
    for (var iKey in myVolunteer) {
      var vol = myVolunteer[iKey];
      var myStartDate = isValidDate(vol.properties.start[0]) ? (0, _dateFns.format)(new Date(vol.properties.start[0]), this.props.dateFormat) : vol.properties.start[0];
      var myEndDate = isValidDate(vol.properties.end[0]) ? (0, _dateFns.format)(new Date(vol.properties.end[0]), this.props.dateFormat) : vol.properties.end[0];
      var myVolLocation = vol.properties.location[0].properties;
      var myElem = /*#__PURE__*/_react.default.createElement("li", {
        key: iKey
      }, this.props.showDate == true ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "dt-start"
      }, myStartDate, " - "), /*#__PURE__*/_react.default.createElement("span", {
        className: "dt-end"
      }, myEndDate, " : ")) : '', /*#__PURE__*/_react.default.createElement("span", {
        className: "p-job-title"
      }, myVolLocation["job-title"], ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-org"
      }, myVolLocation.org, ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-locality"
      }, myVolLocation.locality, ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-region"
      }, myVolLocation.region, " "));
      myElems.push(myElem);
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Volunteer Work"), /*#__PURE__*/_react.default.createElement("ul", null, myElems));
  }
}
exports.ResumeVolunteer = ResumeVolunteer;
_defineProperty(ResumeVolunteer, "propTypes", {
  data: _propTypes.default.object.isRequired,
  dateFormat: _propTypes.default.string.isRequired,
  showDate: _propTypes.default.bool.isRequired
});
class ResumeCertifications extends _react.Component {
  render() {
    var myElems = [];
    var myCerts = this.props.data.items[0].properties.certifications;
    for (var iKey in myCerts) {
      var cert = myCerts[iKey];
      var myStartDate = isValidDate(cert.properties.start[0]) ? (0, _dateFns.format)(new Date(cert.properties.start[0]), this.props.dateFormat) : cert.properties.start[0];
      var myElem = /*#__PURE__*/_react.default.createElement("li", {
        key: iKey
      }, this.props.showDate == true ? /*#__PURE__*/_react.default.createElement("span", {
        className: "dt-start"
      }, myStartDate, " - ") : '', /*#__PURE__*/_react.default.createElement("span", {
        className: "p-name"
      }, cert.properties.name, ", "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p-location"
      }, cert.properties.location));
      myElems.push(myElem);
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Certifications"), /*#__PURE__*/_react.default.createElement("ul", null, myElems));
  }
}
exports.ResumeCertifications = ResumeCertifications;
_defineProperty(ResumeCertifications, "propTypes", {
  data: _propTypes.default.object.isRequired,
  dateFormat: _propTypes.default.string.isRequired,
  showDate: _propTypes.default.bool.isRequired
});
class ResumeSkills extends _react.Component {
  render() {
    var myElems = [];
    var mySkills = this.props.data.items[0].properties.skills[0];
    for (var skill in mySkills) {
      var myElem = /*#__PURE__*/_react.default.createElement("h3", {
        key: "c-" + skill,
        className: "p-skill-category"
      }, skill, " : ");
      myElems.push(myElem);
      var myElem2 = /*#__PURE__*/_react.default.createElement("span", {
        key: "s-" + skill,
        className: "p-skill"
      }, mySkills[skill], /*#__PURE__*/_react.default.createElement("br", null));
      myElems.push(myElem2);
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Skills"), /*#__PURE__*/_react.default.createElement("div", {
      className: "p-skills"
    }, myElems));
  }
}
exports.ResumeSkills = ResumeSkills;
_defineProperty(ResumeSkills, "propTypes", {
  data: _propTypes.default.object.isRequired
});
class ResumeSummary extends _react.Component {
  render() {
    var myElems = [];
    var mySummary = this.props.data.items[0].properties.summary;
    for (var summary in mySummary) {
      var myElem = /*#__PURE__*/_react.default.createElement("li", {
        key: summary
      }, mySummary[summary]);
      myElems.push(myElem);
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Professional Summary"), /*#__PURE__*/_react.default.createElement("ul", {
      className: "p-summary"
    }, myElems));
  }
}
exports.ResumeSummary = ResumeSummary;
_defineProperty(ResumeSummary, "propTypes", {
  data: _propTypes.default.object.isRequired
});